export default __webpack_public_path__ + "static/media/google_white.38ccf163.svg";